import React from "react";
import { Outlet } from "react-router-dom";
import AppHeader from "./AppHeader";
import AppFooter from "./AppFooter";

const AppLayout: React.FC = () => {
  return (
    <div className="app-layout d-flex flex-column min-vh-100">
      <AppHeader />

      <main className="flex-grow-1">
        <Outlet />
      </main>

      <AppFooter />
    </div>
  );
};

export default AppLayout;
